import { Controller } from "stimulus"

export default class extends Controller {
  static values = { text: String }

  copy() {
    navigator.clipboard.writeText(this.textValue).then(() => {
      const icon = this.element.querySelector(".material-icons")
      if (!icon) return

      icon.textContent = "check"
      setTimeout(() => {
        icon.textContent = "content_copy"
      }, 2000)
    })
  }
}
